import { render } from "./GptLogin.vue?vue&type=template&id=b90b1ef6&scoped=true"
import script from "./GptLogin.vue?vue&type=script&lang=js"
export * from "./GptLogin.vue?vue&type=script&lang=js"

import "./GptLogin.vue?vue&type=style&index=0&id=b90b1ef6&scoped=true&lang=less"

import exportComponent from "D:\\zyr\\gptm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b90b1ef6"]])

export default __exports__